import { IRootState } from '../../../store'
import { IPNNVState } from '../store/pnnv.types'

export const getPNNVStateSelector = (state: IRootState): IPNNVState => state.pnnv
